export const schema = (t, validation) => ({
  state: [{ rule: 'requiredArray' }],
  cinema: [{ rule: 'requiredArray' }],
  firstName: [{ rule: 'required' }],
  lastName: [{ rule: 'required' }],
  email: [{ rule: 'required' }, { rule: 'email' }],
  company: [{ rule: 'required' }],
  program: [{ rule: 'required' }],
  // inclusiveType: [{ rule: 'required' }],
  // filmTitle: [{ rule: 'required' }],
  hall: [{ rule: 'required' }],
  terms: [{ rule: 'requiredArray' }],
  preferredDate: [{ rule: 'requiredDate' }],
  timeFrom: [{ rule: 'requiredDate' }],
  timeTo: [{ rule: 'requiredDate' }],
});
